// App.tsx
// Copyright (c) 2020 Neomantra Corp

import React from 'react'
import { Pane } from 'evergreen-ui'
import { Provider } from 'react-redux'
import ToolBar from '../features/toolBar/ToolBar'
import CardGrid from '../features/cardGrid/CardGrid'
import store from '../app/store'

const App = () => {
    return (
        <Provider store={store}>
            <Pane clearfix background='#888' width='100%' height='100%'>
                <ToolBar />
                <Pane padding={5} background='#888' width='100%' height='100%'>
                    <CardGrid />
                </Pane>
            </Pane>
        </Provider>
    )
}

export default App
